import {
  Component,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";

@Component({
  selector: "app-fulle-handle-sidenav",
  templateUrl: "./fulle-handle-sidenav.component.html",
  styleUrls: ["./fulle-handle-sidenav.component.css"],
})
export class FulleHandleSidenavComponent {
   // Inputs — on garde les mêmes noms que la V1 pour brancher direct
  @Input() products$: any;
  @Input() merchantClient$: any;

  @Input() searchProductLoader = false;
  @Input() showSearchInput = false;
  @Input() toggleBasket: any; // bool ou autre (toggleBasketResp côté parent)
  @Input() closeSearch: any;

  // Data affichage panier : dans le HTML actuel j'utilises basket$.length et totalPricePan
  // => en V2 je les expose proprement (pour pouvoir les brancher au service Panier ensuite)
  @Input() basketCount = 0;
  @Input() totalPrice = 0;

  // Outputs — identiques à ce que le parent écoute
  @Output() setShowSearchInputEvent = new EventEmitter<boolean>();
  @Output() setFindedProductsEvent = new EventEmitter<any>(); // null pour reset
  @Output() setSearchProductLoaderEvent = new EventEmitter<boolean>();
  @Output() openBasketEvent = new EventEmitter<void>();

  @Output() resetSearchProductEvent = new EventEmitter<void>();
  @Output() searchProductEvent = new EventEmitter<string>();

  searchProductForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.searchProductForm = this.fb.group({
      searchProductInput: [''],
    });
  }

  openSearchInput(): void {
    this.setShowSearchInput(true);
  }

  setShowSearchInput(v: boolean): void {
    this.setShowSearchInputEvent.emit(v);
    // si je ferme, on reset les résultats
    if (!v) this.setFindedProductsEvent.emit(null);
  }

  openBasket(): void {
    // l’event doit sortir du composant, c’est lui qui déclenche l’ouverture réelle
    this.openBasketEvent.emit();
  }

  onSearchInputChange(): void {
    const value = (this.searchProductForm.get('searchProductInput')?.value ?? '').toString().trim();
    if (!value) {
      this.resetSearchProductEvent.emit();
      return;
    }
    this.searchProductEvent.emit(value);
  }

  resetSearch(): void {
    this.searchProductForm.reset({ searchProductInput: '' });
    this.resetSearchProductEvent.emit();
    this.setFindedProductsEvent.emit(null);
  }
}